import TeamHomeTour from './TeamBadgesTour';

export default TeamHomeTour